import { render, staticRenderFns } from "./RedencionMasivaDialog.vue?vue&type=template&id=06b43a33"
import script from "./RedencionMasivaDialog.vue?vue&type=script&lang=js"
export * from "./RedencionMasivaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports